"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _FrequencyContent = _interopRequireDefault(require("./FrequencyContent.js"));
var _CrosstabContent = _interopRequireDefault(require("./CrosstabContent.js"));
var _OvertimeContent = _interopRequireDefault(require("./OvertimeContent.js"));
var _GroupContent = _interopRequireDefault(require("./GroupContent.js"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var Content = function Content(props) {
  var _currentMetric$conten, _currentMetric$conten2, _currentMetric$conten3;
  var currentMetric = props.currentMetric,
    currentCrossMetric = props.currentCrossMetric,
    data = props.data,
    currentMetricSettings = props.currentMetricSettings,
    deployments = props.deployments;
  var loadingVizData = !data;
  var _useMemo = (0, _react.useMemo)(function () {
      if (loadingVizData) {
        return {};
      }
      var total = {
        total: 0,
        responses: 0,
        skipped: 0
      };
      if (data.frequency) {
        total.total = data.frequency.reduce(function (num, item) {
          return num + item.valueCount;
        }, 0);
        total.responses = data.frequency.filter(function (item) {
          return item.value;
        }).reduce(function (num, item) {
          return num + item.valueCount;
        }, 0);
        total.skipped = data.frequency.filter(function (item) {
          return !item.value;
        }).reduce(function (num, item) {
          return num + item.valueCount;
        }, 0);
      }
      return {
        totalData: total
      };
    }, [data]),
    totalData = _useMemo.totalData;
  var isMatrix = /^mx_/.test((currentMetric === null || currentMetric === void 0 ? void 0 : (_currentMetric$conten = currentMetric.content) === null || _currentMetric$conten === void 0 ? void 0 : _currentMetric$conten.reportHeader) || '');
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].content
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginBottom: '1em'
    }
  }, currentMetricSettings.showLabel ? /*#__PURE__*/_react["default"].createElement("h3", {
    className: _style["default"].title
  }, currentMetric.reportHeader) : null, currentMetricSettings.showVariableLabel && currentMetric.label ? /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].label
  }, currentMetric.label) : null, currentMetricSettings.showQuestion ? /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].question
  }, currentMetric.question, isMatrix && (currentMetric === null || currentMetric === void 0 ? void 0 : (_currentMetric$conten2 = currentMetric.content) === null || _currentMetric$conten2 === void 0 ? void 0 : _currentMetric$conten2.subtitle1) && /*#__PURE__*/_react["default"].createElement("div", null, "Row: ", currentMetric.content.subtitle1), isMatrix && (currentMetric === null || currentMetric === void 0 ? void 0 : (_currentMetric$conten3 = currentMetric.content) === null || _currentMetric$conten3 === void 0 ? void 0 : _currentMetric$conten3.subtitle2) && /*#__PURE__*/_react["default"].createElement("div", null, "Column: ", currentMetric.content.subtitle2)) : null, !loadingVizData && currentMetricSettings.showTotalResponses ? /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].summary
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("b", null, totalData.total), " total submissions"), /*#__PURE__*/_react["default"].createElement("div", null, "|"), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("b", null, totalData.responses), " responses"), /*#__PURE__*/_react["default"].createElement("div", null, "|"), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("b", null, totalData.skipped), " skipped")) : null), function () {
    if (loadingVizData) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '2em'
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: true,
        type: "inline"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "text-center",
        style: {
          marginTop: '0.3em'
        }
      }, "Loading"));
    }
    var hasData = totalData.responses > 0;
    if (!hasData) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          textAlign: 'center',
          margin: '5em',
          color: '#d9d9d9'
        }
      }, /*#__PURE__*/_react["default"].createElement("h2", null, "Zero responses for this metric"));
    }
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, currentMetricSettings.aboveChart && /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: currentMetricSettings.aboveChart
    }), currentMetricSettings.comparison === 'none' && /*#__PURE__*/_react["default"].createElement(_FrequencyContent["default"], {
      currentMetric: currentMetric,
      currentMetricSettings: currentMetricSettings,
      data: data
    }), currentMetricSettings.comparison === 'crosstab' && /*#__PURE__*/_react["default"].createElement(_CrosstabContent["default"], {
      currentMetric: currentMetric,
      currentMetricSettings: currentMetricSettings,
      currentCrossMetric: currentCrossMetric,
      data: data
    }), currentMetricSettings.comparison === 'overtime' && /*#__PURE__*/_react["default"].createElement(_OvertimeContent["default"], {
      currentMetric: currentMetric,
      currentMetricSettings: currentMetricSettings,
      data: data,
      deployments: deployments
    }), currentMetricSettings.comparison === 'grouptype' && /*#__PURE__*/_react["default"].createElement(_GroupContent["default"], {
      currentMetric: currentMetric,
      currentMetricSettings: currentMetricSettings,
      data: data,
      deployments: deployments
    }), currentMetricSettings.belowChart && /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: currentMetricSettings.belowChart
    }));
  }());
};
Content.propTypes = {
  currentMetric: _propTypes["default"].object,
  currentCrossMetric: _propTypes["default"].object,
  data: _propTypes["default"].object,
  currentMetricSettings: _propTypes["default"].object,
  deployments: _propTypes["default"].array
};
var _default = exports["default"] = Content;